import { products, pricingRules } from './products.js';

// These are buying situations, not new products, SKU groups or stock records.
// All configuration and prices remain owned by the existing product catalog.
export const buyerLandingPages = Object.freeze([
  {
    key: 'business-apparel',
    path: '/business-apparel',
    navLabel: 'ביגוד לעסקים',
    seoTitle: 'ביגוד ממותג לעסקים ולצוותים | Printeam',
    seoDescription: 'בחרו פולו, טריקו, דרייפיט או קפוצ׳ון לצוות שלכם. משווים מוצרים ומחירי בגד לפי כמות, וממשיכים לבחירת צבעים, מידות ומיתוג בדף המוצר.',
    eyebrow: 'ביגוד לעסקים ולצוותים',
    title: 'הזהות של העסק. הביגוד של הצוות.',
    description: 'פולו, טריקו או שכבה לימים הקרים — בוחרים פריט, מזינים מידות וכמויות ומוסיפים את הלוגו שלכם.',
    heroSku: 'polo',
    heroColor: 'navy',
    heroAlt: 'חולצת פולו כחולה כהה מתוך קטלוג Printeam, לפני מיתוג',
    primaryLabel: 'לבחירת ביגוד לצוות',
    selectionTitle: 'מה מתאים ליום העבודה שלכם?',
    selectionIntro: 'התחילו מסוג הבגד. את הצבעים, המידות, הכמויות ואזורי המיתוג בוחרים בדף המוצר.',
    products: [
      { sku: 'polo', label: 'פולו', reason: 'חולצה עם צווארון למראה צוות אחיד. הרכב הבד: 60% כותנה ו־40% פוליאסטר.' },
      { sku: 'tshirt', label: 'טריקו', reason: 'חולצת 100% כותנה למיתוג יום־יומי, עם אפשרויות מיקום ללוגו או לעיצוב.' },
      { sku: 'dryfit', label: 'דרייפיט', reason: 'חולצת 100% פוליאסטר — אפשרות לביגוד לצוותים ולפעילות.' },
      { sku: 'hoodie', label: 'קפוצ׳ון', reason: 'שכבה נוספת לצוות בימים הקרים. הרכב הבד: 65% כותנה ו־35% פוליאסטר.' },
    ],
    preparationTitle: 'לפני שמתחילים להזמין לצוות',
    preparation: [
      { title: 'רשימת מידות וכמויות', body: 'אספו את הכמות הנדרשת בכל צבע ומידה. בדף המוצר כל בחירה נשמרת בנפרד.' },
      { title: 'לוגו ומיקום המיתוג', body: 'הכינו את קובץ הלוגו ובחרו את אזורי המיתוג מתוך האפשרויות של הפריט.' },
      { title: 'מועד שבו הביגוד דרוש', body: 'אם יש תאריך קבוע, בדקו איתנו את ההתאמה לפני ההזמנה. זמן האספקה הוא הערכה, ולא התחייבות לתאריך.' },
    ],
    worksText: 'רוצים לראות דוגמאות למיתוג על ביגוד? בגלריה מוצגות עבודות שבוצעו ב־Printeam.',
    finalTitle: 'בוחרים את הבגד. ממשיכים ללוגו שלכם.',
    relatedLinks: [
      { to: '/catalog?filter=winter', label: 'לביגוד חורף נוסף' },
      { to: '/headwear/branded-caps', label: 'לכובעים ממותגים' },
    ],
  },
  {
    key: 'group-shirts',
    path: '/group-shirts',
    navLabel: 'חולצות לקבוצות',
    seoTitle: 'חולצות לקבוצות, צוותים ואירועים | Printeam',
    seoDescription: 'חולצות וקפוצ׳ונים בעיצוב של הקבוצה שלכם. בוחרים פריט, מכינים כמויות לפי צבע ומידה, מעלים עיצוב ובודקים את המחיר לפי ההזמנה.',
    eyebrow: 'לקבוצות, צוותים ואירועים',
    title: 'העיצוב שלכם. החולצה של כולם.',
    description: 'לקבוצה, לפעילות או לאירוע — מתחילים בבגד המתאים, אוספים מידות ומעלים את העיצוב שמחבר ביניכם.',
    heroSku: 'dryfit',
    heroColor: 'blue',
    heroAlt: 'חולצת דרייפיט כחולה מתוך קטלוג Printeam, לפני מיתוג',
    primaryLabel: 'לבחירת בגד לקבוצה',
    selectionTitle: 'איזה בגד מתאים לפעילות שלכם?',
    selectionIntro: 'טריקו מכותנה, דרייפיט מפוליאסטר או קפוצ׳ון — לכל פריט אפשרויות צבע, מידה ומיתוג משלו.',
    products: [
      { sku: 'tshirt', label: 'טריקו', reason: 'חולצת 100% כותנה לעיצוב של הקבוצה, ליום משותף או לאירוע.' },
      { sku: 'dryfit', label: 'דרייפיט', reason: 'חולצת 100% פוליאסטר לקבוצות שמחפשות ביגוד לפעילות.' },
      { sku: 'hoodie', label: 'קפוצ׳ון', reason: 'למפגשים ולעונות הקרות, עם העיצוב של הקבוצה על אזורי המיתוג שתבחרו.' },
    ],
    preparationTitle: 'שלושה דברים שכדאי לאסוף מהקבוצה',
    preparation: [
      { title: 'כמויות לפי צבע ומידה', body: 'רשימה מסודרת עוזרת לבנות את ההזמנה. בוחרים ומזינים את הכמויות בדף המוצר.' },
      { title: 'קובץ עיצוב מוסכם', body: 'הכינו את העיצוב ובחרו מי מרכז את אישור ההדמיה לפני שההזמנה עוברת לייצור.' },
      { title: 'תאריך האירוע', body: 'יש מועד קבוע? בדקו איתנו מראש את לוח הזמנים ואת התאמת המוצר להזמנה.' },
    ],
    worksText: 'מחפשים כיוון לעיצוב? אפשר לראות בגלריה דוגמאות לעבודות הדפסה ומיתוג שבוצעו באתר.',
    finalTitle: 'הקבוצה כבר כאן. עכשיו בוחרים את הבגד.',
    relatedLinks: [
      { to: '/catalog?filter=winter', label: 'לביגוד חורף לקבוצה' },
      { to: '/headwear/tembel-hats', label: 'לכובעי טמבל ופטרייה' },
    ],
  },
  {
    key: 'personal-design',
    path: '/personal-design',
    navLabel: 'העיצוב האישי שלכם',
    seoTitle: 'חולצה או קפוצ׳ון בעיצוב אישי, גם יחידה אחת | Printeam',
    seoDescription: 'העלו את העיצוב שלכם לחולצה או לקפוצ׳ון. אפשר להזמין גם יחידה אחת, לבחור צבע ומידה ולראות את המחיר עם אפשרויות המיתוג שבחרתם.',
    eyebrow: 'העיצוב שלכם, על הבגד שלכם',
    title: 'משהו שיצרתם. משהו ללבוש.',
    description: 'איור, לוגו או עיצוב משלכם — בוחרים חולצה או קפוצ׳ון, מעלים קובץ וממקמים אותו. אפשר להזמין גם יחידה אחת.',
    heroSku: 'hoodie',
    heroColor: 'gray',
    heroAlt: 'קפוצ׳ון אפור מתוך קטלוג Printeam, לפני מיתוג',
    primaryLabel: 'לבחירת הבגד לעיצוב שלכם',
    selectionTitle: 'על מה תרצו את העיצוב שלכם?',
    selectionIntro: 'בחרו בגד והמשיכו למסך העיצוב. המחיר הסופי מחושב לפי הפריט, הכמות ואפשרויות המיתוג שבחרתם.',
    products: [
      { sku: 'tshirt', label: 'טריקו', reason: 'חולצת 100% כותנה עם אפשרויות להדפסה בחזית, בגב ובאזורים נוספים המוצגים בדף המוצר.' },
      { sku: 'hoodie', label: 'קפוצ׳ון', reason: 'קפוצ׳ון בהרכב 65% כותנה ו־35% פוליאסטר, עם אפשרויות מיתוג בחזית, בגב ובשרוולים.' },
    ],
    preparationTitle: 'מה צריך כדי להתחיל?',
    preparation: [
      { title: 'קובץ העיצוב שלכם', body: 'הכינו קובץ שיש לכם זכות להשתמש בו. מעלים אותו וממקמים באזורי המיתוג הזמינים לפריט.' },
      { title: 'צבע ומידה', body: 'בחרו מתוך אפשרויות הפריט בדף המוצר. תמונת הבגד כאן אינה בחירת צבע להזמנה.' },
      { title: 'בדיקה לפני הייצור', body: 'בדקו את פרטי ההזמנה. הזמנה עם מיתוג עוברת אישור הדמיה לפני תחילת הייצור.' },
    ],
    worksText: 'רוצים לראות איך עיצוב נראה על בגד? בגלריה מוצגות עבודות על חולצות, קפוצ׳ונים ומוצרים נוספים.',
    finalTitle: 'העיצוב שלכם מוכן לבגד משלו.',
    relatedLinks: [
      { to: '/group-shirts', label: 'מזמינים לכמה אנשים? לחולצות לקבוצות' },
      { to: '/catalog', label: 'לכל המוצרים' },
    ],
  },
].map((landing) => Object.freeze(landing)));

export const buyerLandingPageMap = Object.freeze(
  Object.fromEntries(buyerLandingPages.map((landing) => [landing.key, landing])),
);

export function resolveBuyerProducts(landing, catalog = products, rules = pricingRules) {
  return landing.products.map((selection) => {
    const matches = catalog.filter((product) => product.sku === selection.sku);
    if (matches.length !== 1) {
      throw new Error(`Expected one catalog record for buyer landing SKU "${selection.sku}"`);
    }
    const tiers = rules[selection.sku]?.tiers;
    if (!Array.isArray(tiers) || !tiers.length || tiers.some((tier) => (
      !Number.isFinite(tier.price) || tier.price < 0 || !Number.isInteger(tier.min)
      || tier.min < 1 || !(tier.max === Infinity || Number.isInteger(tier.max)) || tier.max < tier.min
    ))) {
      throw new Error(`Missing or invalid canonical pricing tiers for buyer landing SKU "${selection.sku}"`);
    }
    return { ...selection, product: matches[0], tiers };
  });
}
